export class LocalDev {
  constructor() {}

  private readonly isLive = process.env.NODE_ENV !== "development";

  public init() {
    if (this.isLive) return;
    window.localStorage.setItem("PopularBetBuildersLogs", "true");
    window.localStorage.setItem("PBB_TEST", "true");
  }
}
